import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { AppTopbar } from './AppTopbar';
import { AppMenu } from './AppMenu';
import PrimeReact from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css';   
import 'primeflex/primeflex.css';                                  
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import './assets/layout/layout.scss';
import './App.css';
import './override.css';
import { useStoreActions, useStoreState } from 'easy-peasy';
import CustomRoute from './CustomRoute';
import { Route, useHistory } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Master from './components/admin/Master';
import Projects from './components/admin/projects/Projects';
import ProjectsHOD from './components/hodUser/ProjectsHOD';
import ClientRegistry from './components/admin/projects/ClientRegistry';
import ProjectsDefinition from './components/admin/projects/ProjectsDefinition';
import DashboardProjects from './components/admin/projects/DashboardProjects';
import SessionExpiredModel from './SessionExpiredModel';
import FileViewer from './components/hodUser/FileViewer';
import DashboardIcon from './components/hodUser/DashboardIcon';
import TaskDashboard from './components/admin/projects/TaskDashboard';
import ProjectsRegisterHod from './components/hodUser/FromAdmin/ProjectsRegisterHod';
import { Tooltip } from 'primereact/tooltip';
import DashboardIconMenu from './images/dashboardIconMenu.svg';

const App = () => {
    const [layoutMode, setLayoutMode] = useState('static');
    const [layoutColorMode, setLayoutColorMode] = useState('light')
    const [inputStyle, setInputStyle] = useState('outlined');
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const copyTooltipRef = useRef();
    const location = useLocation();
    const [isAuthScreen, setAuthScreen] = useState(true);
    const user = useStoreState((actions) => actions.loginModel.user);
    const setEvaluationViewDatas = useStoreActions((actions) => actions.sipModel.setEvaluationViewDatas);
    const evaluationViewDatas = useStoreState((actions) => actions.sipModel.evaluationViewDatas);
    const setPath = useStoreActions((actions) => actions.tabModel.setPath);
    const setMenuIcon = useStoreActions((actions) => actions.projectModel.setMenuIcon);
    const menuIcon = useStoreState((actions) => actions.projectModel.menuIcon);
    // console.log(user);

    useEffect(() => {
        setEvaluationViewDatas(null);
        setMenuIcon(false);
    }, []);

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;


    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    useEffect(() => {
        copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    }, [location]);

    useEffect(()=>{
        if(["/login","/register"].includes(location.pathname)){
            // console.log(location.pathname)
            setAuthScreen(true)
            setStaticMenuInactive(true)
        }else{
            // console.log(location.pathname)
            const path_route = (location.pathname == "/app/defaultnav" || location.pathname == "/app/projects" || location.pathname == "/app/employee")
            setPath(path_route)
            setAuthScreen(false)
            setStaticMenuInactive(false)
        }
        // console.log(location.pathname)
    },[location.pathname])

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
            // setMenuIcon(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
            // setMenuIcon(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
        // menuIcon(false);
    }

    const onToggleMenuClick = (event) => {
        menuClick = true;
        setMenuIcon(!menuIcon);

        if (isDesktop()) {
            if (layoutMode === 'overlay') {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
                // setMenuIcon((prevState) => !prevState);
                
            }
            else if (layoutMode === 'static') {
                setStaticMenuInactive((prevState) => !prevState);
                // setMenuIcon((prevState) => !prevState);
            }
        }
        else {
            setMobileMenuActive((prevState) => !prevState);
            // setMenuIcon((prevState) => !prevState);
        }

        event.preventDefault();
    }
    
    // console.log("menu:", menuIcon);
    const onSidebarClick = () => {
        menuClick = true;
    }

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    }

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    }

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    }
    const isDesktop = () => {
        return window.innerWidth >= 992;
    }

    const menuAPQPAdmin = [
        {
            label: "",
            items: [
                { label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/app/defaultnav', className: 'custom-icon' },
                ...(user?.user?.module_access?.includes("Project Register") ? [
                { label: 'Projects Register', icon: 'pi pi-fw pi-file', to: '/app/projects-projects' }] : []),
                ...(user?.user?.module_access?.includes("Tasks Dashboard") ? [
                { label: 'Tasks Dashboard', icon: 'pi pi-fw pi-folder', to: '/app/tasks-dashboard' }] : []),
                ...(user?.user?.module_access?.includes("Task Register") ? [
                { label: 'Task Register', icon: 'pi pi-fw pi-check-square', to: '/app/projects-definition' }] : []),
                ...(user?.user?.module_access?.includes("Customer Registry") ? [
                { label: 'Customer Registry', icon: 'pi pi-fw pi-calendar-plus', to: '/app/projects-client-registry' }] : []),
                ...(user?.user?.module_access?.includes("Master") ? [
                { label: 'Master', icon: 'pi pi-fw pi-file-edit', to: '/app/employee' }] : []),
            ]
        },
    ];

    const menuAdmin = [
        {
            label: "",
            items: [
                { icon: 'pi pi-fw pi-home', to: '/app/defaultnav' , tooltip: 'Dashboard' },
                ...(user?.user?.module_access?.includes("Project Register") ? [
                { icon: 'pi pi-fw pi-file', to: '/app/projects-projects' , tooltip: 'Projects Register'}] : []),
                ...(user?.user?.module_access?.includes("Tasks Dashboard") ? [
                { icon: 'pi pi-fw pi-folder', to: '/app/tasks-dashboard' , tooltip: 'Tasks Dashboard' }] : []),
                ...(user?.user?.module_access?.includes("Task Register") ? [
                { icon: 'pi pi-fw pi-check-square', to: '/app/projects-definition' , tooltip: 'Task Register'}] : []),
                ...(user?.user?.module_access?.includes("Customer Registry") ? [
                { icon: 'pi pi-fw pi-calendar-plus', to: '/app/projects-client-registry' , tooltip: 'Customer Registry' }] : []),
                ...(user?.user?.module_access?.includes("Master") ? [
                { icon: 'pi pi-fw pi-file-edit', to: '/app/employee' , tooltip: 'Master' }] : []),
            ]
        },
    ];

    
    
    const menuUser = [
        {
            label: "",
            items: [
                // {
                //     label: (
                //         <>
                //             <div className='icon_hover text-align-center align-item-center flex justify-content-center'>
                //                 <DashboardIcon color={location.pathname.startsWith('/app/defaultnav') ? '#E6FB2D' : '#D3D3D3'} />
                //                 <span className='text-center flex align-items-center justify-content-center'>Dashboard </span>
                //             </div>
                //         </>
                //     ),
                //     to: '/app/defaultnav'
                // },
                
                { label: 'Dashboard', icon:'pi pi-fw pi-home', to: '/app/defaultnav' },
                ...(user?.user?.module_access?.includes("Projects Register") ? [
                { label: 'Projects Register', icon:'pi pi-fw pi-file', to: '/app/us-projects-register' }] : []),
                ...(user?.user?.module_access?.includes("Task Register") ? [
                { label: 'Task Dashboard', icon:'pi pi-fw pi-folder', to: '/app/us-projects' }] : []),
                ...(user?.user?.module_access?.includes("File Viewer") ? [
                { label: 'File Viewer', icon:'pi pi-fw pi-check-square', to: '/app/us-fileviewer' }] : []),
            ]
        },
    ];

    const menuIconUser = [
        {
            label: "",
            items: [
                {icon:'pi pi-fw pi-home', to: '/app/defaultnav', tooltip: 'Dashboard' },
                ...(user?.user?.module_access?.includes("Projects Register") ? [
                { icon:'pi pi-fw pi-file', to: '/app/us-projects-register', tooltip: 'Projects Register' }] : []),
                ...(user?.user?.module_access?.includes("Task Register") ? [
                {  icon:'pi pi-fw pi-folder', to: '/app/us-projects', tooltip: 'Task Register' }] : []),
                ...(user?.user?.module_access?.includes("File Viewer") ? [
                { icon:'pi pi-fw pi-check-square', to: '/app/us-fileviewer', tooltip: 'File Viewer'}] : []),
            ]
        },
    ];


    const addClass = (element, className) => {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    const removeClass = (element, className) => {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    const wrapperClass = classNames('layout-wrapper', {
        'layout-overlay': layoutMode === 'overlay',
        'layout-static': layoutMode === 'static',
        // 'layout-static-sidebar-inactive': staticMenuInactive && layoutMode === 'static',
        // 'layout-overlay-sidebar-active': overlayMenuActive && layoutMode === 'overlay',
        // 'layout-mobile-sidebar-active': mobileMenuActive,
        'p-input-filled': inputStyle === 'filled',
        'p-ripple-disabled': ripple === false,
        'layout-theme-light': layoutColorMode === 'light'
    });

    // session expired
    const [sessionExpired, setSessionExpired] = useState(false);
    const history = useHistory();

    useEffect(() => {
        const tokenExpiryHandler = () => {
            setSessionExpired(true);
        };

        const tokenExpiryTime = new Date(user?.time).getTime();
        const tenDaysInMilliseconds = 10 * 24 * 3600000;
        const newTokenExpiryTime = tokenExpiryTime + tenDaysInMilliseconds;
        const currentTime = new Date().getTime();
        const timeUntilExpiry = newTokenExpiryTime - currentTime;
        // console.log(newTokenExpiryTime, currentTime, (newTokenExpiryTime - currentTime), new Date(newTokenExpiryTime));

        if (timeUntilExpiry > 0) {
            setTimeout(tokenExpiryHandler, timeUntilExpiry);
        } else {
            tokenExpiryHandler();
        }
        // console.log("Token expiry time:", new Date(newTokenExpiryTime).toLocaleString());  

        return () => clearTimeout(tokenExpiryHandler);
    }, []);

    const handleSessionExpired = () => {
        setSessionExpired(false);
        history.push('/');
    };
    // console.log(new Date(user?.time));

    return (
        <div className={wrapperClass} onClick={onWrapperClick}>
            {
               isAuthScreen === false && (
                    <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />
               )
            }
                {isAuthScreen === false && (
                    <div className={!menuIcon ? "layout-sidebar" : "layout-sidebar-icons"} onClick={onSidebarClick}>
                        <AppMenu
                            model={["admin", "superadmin", "manager"].includes(user?.user?.role?.[0]) ? (!menuIcon ? menuAPQPAdmin : menuAdmin)  : (!menuIcon ? menuUser : menuIconUser)}
                            onMenuItemClick={onMenuItemClick}
                            layoutColorMode={layoutColorMode}
                        />
                    </div>
                )}

            <SessionExpiredModel visible={sessionExpired} onHide={handleSessionExpired} />

            <div className={!menuIcon ? "layout-main-container" : "layout-main-container-menu-icons"} >
                <div className="layout-main">
                <Route 
                        exact 
                        path="/app/defaultnav" 
                        component={["admin", "superadmin", "manager"].includes(user?.user?.role?.[0]) ? DashboardProjects : Dashboard} 
                    />

                    {/* <CustomRoute path="/app/projects-dashboard" component={DashboardProjects} 
                        allowedRoles={["admin"]} currentUserRoles={user?.user?.role} /> */}
                    <CustomRoute path="/app/projects-projects" component={Projects} 
                        allowedRoles={["admin","superadmin","manager"]} currentUserRoles={user?.user?.role} />
                    <CustomRoute path="/app/tasks-dashboard" component={TaskDashboard} 
                        allowedRoles={["admin","superadmin","manager"]} currentUserRoles={user?.user?.role} />
                    <CustomRoute path="/app/projects-definition" component={ProjectsDefinition} 
                        allowedRoles={["admin","superadmin","manager"]} currentUserRoles={user?.user?.role} />
                    <CustomRoute path="/app/projects-client-registry" component={ClientRegistry} 
                        allowedRoles={["admin","superadmin","manager"]} currentUserRoles={user?.user?.role} />

                    <CustomRoute path="/app/employee" component={Master} 
                        allowedRoles={["admin","superadmin","manager"]} currentUserRoles={user?.user?.role} />
                    
                    {/* <CustomRoute exact path="/app/defaultnav" component={Dashboard} 
                        allowedRoles={["HOD", "User"]} currentUserRoles={user?.user?.role} /> */}
                    <CustomRoute path="/app/us-projects-register" component={ProjectsRegisterHod} 
                        allowedRoles={["user"]} currentUserRoles={user?.user?.role} />
                    <CustomRoute path="/app/us-projects" component={ProjectsHOD} 
                        allowedRoles={["user"]} currentUserRoles={user?.user?.role} />
                        <CustomRoute path="/app/us-fileviewer" component={FileViewer} 
                        allowedRoles={["user"]} currentUserRoles={user?.user?.role} />
                       
                </div>
            </div>

            <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                <div className="layout-mask p-component-overlay"></div>
            </CSSTransition>

        </div>
        
    );

}

export default App;
